var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row justify-center q-pb-md q-pt-xs"},[_c('div',{staticClass:"full-width width-custom q-px-md"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }